import { SITE_URL } from "../config/env";

export const SITE_NAME = "Simpary";

const FALLBACK_SITE_URL = "https://simpary.com";

export const DEFAULT_SITE_URL = SITE_URL || FALLBACK_SITE_URL;

export const DEFAULT_OG_IMAGE_PATH = "/og-default.jpg";

export const getSiteOrigin = () => {
  if (SITE_URL) return String(SITE_URL).replace(/\/$/, "");
  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.origin &&
    !/localhost|127\.0\.0\.1/.test(window.location.origin)
  ) {
    return window.location.origin.replace(/\/$/, "");
  }
  return FALLBACK_SITE_URL;
};

export const getCanonicalUrl = (pathname = "/") => {
  const origin = getSiteOrigin();
  if (!pathname || pathname === "/") {
    return `${origin}/`;
  }
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${origin}${normalizedPath}`;
};

export const getAbsoluteAssetUrl = (assetPath = DEFAULT_OG_IMAGE_PATH) => {
  if (!assetPath) return `${getSiteOrigin()}${DEFAULT_OG_IMAGE_PATH}`;
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  const normalizedPath = assetPath.startsWith("/") ? assetPath : `/${assetPath}`;
  return `${getSiteOrigin()}${normalizedPath}`;
};

/**
 * Brand-suffixed document title. react-helmet-async v3 on React 19 hoists
 * <title> natively and does not reliably apply Helmet titleTemplate, so we
 * format the final title here instead of relying on App.js.
 */
export const formatPageTitle = (title) => {
  const trimmed = String(title || "").trim();
  if (!trimmed || trimmed === SITE_NAME) return SITE_NAME;
  if (trimmed.includes(SITE_NAME)) return trimmed;
  return `${trimmed} | ${SITE_NAME}`;
};
